// StudentNoteModal.jsx
import React, { useState, useEffect } from 'react';
import { XIcon } from 'lucide-react';
import './StudentNoteModal.css';

const StudentNoteModal = ({ isOpen, onClose, student, onSaveNote }) => {
    const [noteContent, setNoteContent] = useState('');

    useEffect(() => {
        if (isOpen && student) {
            setNoteContent(student.anotacoesPrivadas || '');
        }
    }, [isOpen, student]);

    useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        if (isOpen) {
            window.addEventListener('keydown', handleEsc);
        }
        return () => {
            window.removeEventListener('keydown', handleEsc);
        };
    }, [isOpen, onClose]);

    if (!isOpen || !student) {
        return null;
    }

    const handleSave = () => {
        if (onSaveNote) {
            onSaveNote(student.id, noteContent);
        }
        onClose();
    };

    return (
        <div className="snm-modal-overlay">
            <div role="dialog" className="snm-modal-content">
                <button onClick={onClose} className="snm-close-button">
                    <XIcon className="snm-close-icon" />
                    <span className="snm-sr-only">Fechar</span>
                </button>

                <div className="snm-header">
                    <h2 className="snm-title">Adicionar Anotação</h2>
                </div>
                <p className="snm-description">
                    Adicione ou edite uma anotação privada sobre {student.name}
                </p>

                <div className="snm-body">
                    <div className="snm-form-group">
                        <label htmlFor="student-note" className="snm-label">Anotação</label>
                        <textarea
                            id="student-note"
                            className="snm-textarea"
                            placeholder="Digite sua anotação aqui..."
                            value={noteContent}
                            onChange={(e) => setNoteContent(e.target.value)}
                            rows={6}
                        />
                    </div>
                </div>

                <div className="snm-footer">
                    <button onClick={onClose} className="snm-button snm-button-secondary">
                        Cancelar
                    </button>
                    <button onClick={handleSave} className="snm-button snm-button-primary">
                        Salvar Anotação
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StudentNoteModal;